export default __webpack_public_path__ + "c16813fe6ef977aaa21aaee3db2ac45f.ttf";